import React, {Component} from 'react';

const WhyBook = props => (
    <>
        <div className="full-width-block white">
            <div className="row no-padding">
                <div className="column">
                    <h3 className="mg-b-lrg">Why book with us?</h3>
                </div> 
            </div> 
        </div>

        <div className="full-width-block white">
            <div className="row no-padding">
                <div className="column">

                    <div className="align-content vertical start mg-b">
                        <div className="icon-holder border secondary-stag-primary-hen thick round mg-r">
                            <span className={props.siteId == 1 ? "icon icon-shield secondary-stag-primary-hen" : "icon icon-tag secondary-stag-primary-hen"}></span>
                        </div>
                        {props.siteId == 1 ?
                            <div>
                                <h4 className="secondary-stag-primary-hen no-mg-b">Price match promise</h4>
                                <p>We offer the cheapest prices around - if you find a like-for-like {props.siteId == 1 ? 'stag' : 'hen'} do for less, we'll match it!</p>
                            </div>
                        : 
                            <div>
                                <h4 className="secondary-stag-primary-hen no-mg-b">Secure the hen for just &pound;1</h4>
                                <p>Book early to get the best price and only part with &pound;1</p>
                            </div>
                        }
                    </div>

                    <div className="align-content vertical start mg-b">
                        <div className="icon-holder border secondary-stag-primary-hen thick round mg-r">
                            <span className={props.siteId == 1 ? "icon icon-group secondary-stag-primary-hen" : "icon icon-pay secondary-stag-primary-hen" }></span>
                        </div>
                        {props.siteId == 1 ?
                            <div>
                                <h4 className="secondary-stag-primary-hen no-mg-b">Finalise group size later</h4>
                                <p>Change your group size after paying your deposit. (subject to price and availability)</p>
                            </div>
                        :
                            <div>
                                <h4 className="secondary-stag-primary-hen no-mg-b">Unbeatable deals</h4>
                                <p>Explore fun and affordable activities and stays to suit every taste and budget.</p>
                            </div>
                        }
                    </div>
                    

                    <div className="spacer small"></div>

                    <div className="align-content vertical start mg-b">
                        <div className="icon-holder border secondary-stag-primary-hen thick round mg-r">
                            <span className={props.siteId == 1 ? "icon icon-pay secondary-stag-primary-hen" : "icon icon-cash secondary-stag-primary-hen" }></span>
                        </div>
                        {props.siteId == 1 ?
                            <div>
                                <h4 className="secondary-stag-primary-hen no-mg-b">Monthly instalments</h4>
                                <p>0% interest and 'as and when' plans. <a className="link black underline" target="_blank" href="/part-payments">More</a></p>
                            </div>
                        :
                            <div>
                                <h4 className="secondary-stag-primary-hen no-mg-b">Each guest chooses how they pay</h4>
                                <p>Flexible payment options - pay in full, via interest-free monthly instalments, or 'as and when'. <a className="link black underline" target="_blank" href="/part-payments">More</a></p>
                            </div>
                        }
                    </div>

                    <div className="spacer small"></div>

                    <div className="align-content vertical start mg-b">
                        <div className="icon-holder border secondary-stag-primary-hen thick round mg-r">
                            <span className={props.siteId == 1 ? "icon icon-thumbup secondary-stag-primary-hen" : "icon icon-starempty secondary-stag-primary-hen"}></span>
                        </div>
                        <div>
                            <h4 className="secondary-stag-primary-hen no-mg-b">{props.siteId == 1 ? 'The Stag Company' : 'Hen Party Deals'} Flex</h4>
                            {props.siteId == 1 ?
                                <p>Extra booking amendment flexibility, just &pound;4.95pp. <a className="link black underline" target="_blank" href="/part-payments">More</a></p>
                            :
                                <p>Just &pound;4.95pp for <strong>FREE</strong> cancellation, amendments and extra peace of mind. <a className="link black underline" target="_blank" href="/part-payments">More</a></p>
                            }
                        </div>
                    </div>

                    <div className="spacer small"></div>

                    <div className="align-content vertical start mg-b">
                        <div className="icon-holder border secondary-stag-primary-hen thick round mg-r">
                            <span className="icon icon-singlebed secondary-stag-primary-hen"></span>
                        </div>
                        {props.siteId == 1 ?
                            <div>
                                <h4 className="secondary-stag-primary-hen no-mg-b">Superb accommodation</h4>
                                <p>Hand-picked for all tastes and budgets.</p>
                            </div>
                        :
                            <div>
                                <h4 className="secondary-stag-primary-hen no-mg-b">Hen-friendly accommodation</h4>
                                <p>Our accommodation experts hand-pick the perfect stays for every taste and budget.</p>
                            </div>
                        }
                    </div>

                    <div className="spacer small"></div>
                    {props.siteId == 1 ?
                        <div className="align-content vertical start mg-b">
                            <div className="icon-holder border secondary-stag-primary-hen thick round mg-r">
                                <span className="icon icon-certificate secondary-stag-primary-hen"></span>
                            </div>
                            <div>
                                <h4 className="secondary-stag-primary-hen no-mg-b">We're rated 'Excellent'</h4>
                                <p>5 stars and 1600+ <a href="https://uk.trustpilot.com/review/thestagcompany.com?utm_medium=trustbox&utm_source=MicroCombo" target="_blank" className="link black underline">Trustpilot</a> reviews.</p>
                            </div>
                        </div>
                    : null }
                </div> 
            </div> 
        </div>
    </>

);

export default WhyBook